module.exports = __webpack_public_path__ + "static/media/reguas-de-marcas-UNA-SUS_gruposaite.45dd116b.png";